import * as React from 'react';
// import { useState, useEffect } from 'react';
import AccountDetailHeader from './AccountDetailHeader';
import { SponsorAccountList } from './SponsorAccountList';
import System from 'src/helper/system';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import SystemAlerts from 'src/component/SystemAlerts';
import AdminConsoleHeader from '../AdminConsoleHeader';
import useReduxState from 'src/hooks/useReduxState';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag.js';

const c = System.getParams();


const AccountDetail = () => {
  const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
  const [userListErrAlert, setUserListErrAlert] = useReduxState("", 'setUserListErrAlert');
  const [errAlertType] = useReduxState("", 'setErrAlertType');

  return (
    <>
      <div className='adminconsole-container'>
        <AdminConsoleHeader title={'ACCOUNT DETAILS'} />
        <div className="bs5 row mt-2">
          <div className='col-12'>
            {(latest_system_notification_data?.errorModule !== undefined && latest_system_notification_data?.errorModule === 'userAcct') &&
              <SystemAlerts />
            }
            {userListErrAlert &&
              <AlertContentWithFlag message={userListErrAlert} type={errAlertType ? errAlertType : "danger"} isDisplay={errAlertType == 'success' ? true : false} isDisplayIcon={errAlertType == 'danger' ? true : false} callBackFunc={() => {
                setUserListErrAlert('');
              }} />
            }
          </div>
        </div>

        <AccountDetailHeader accountDetails={c} />

        <SponsorAccountList accountDetails={c} />
      </div>
    </>
  );
}

export default AccountDetail;